/* unplugin-vue-components disabled */import { render } from "./test-agents.vue?vue&type=template&id=29c87a9b&scoped=true"
import script from "./test-agents.vue?vue&type=script&lang=js"
export * from "./test-agents.vue?vue&type=script&lang=js"

import "./test-agents.vue?vue&type=style&index=0&id=29c87a9b&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c87a9b"],['__file',"src/pages/settings/admin/test-agents/test-agents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29c87a9b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29c87a9b', __exports__)) {
    api.reload('29c87a9b', __exports__)
  }
  
  module.hot.accept("./test-agents.vue?vue&type=template&id=29c87a9b&scoped=true", () => {
    api.rerender('29c87a9b', render)
  })

}


export default __exports__